export enum SearchError {
    NoError = "NoError",
    MarketNotFound = "MarketNotFound",
    LanguageNotFound = "LanguageNotFound",
    EmptyEditionParam = "EmptyEditionParam",
    EmptyMarketParam = "EmptyMarketParam",
    EmptyLanguageParam = "EmptyLanguageParam",
    ModelNotFound = "ModelNotFound",
    EditionNotFound = "EditionNotFound",
    NoManuals = "NoManuals",
    RequestError = "RequestError",
    UnrecoginzedVin = "UnrecognizedVin",
    ParametersMismatch = "ParametersMismatch"
}